import { createContext } from 'react'

export interface OnboardingAppContextValues {
  authToken: string
  bookmarkletJS: string
  deviceSupportsBabylistApp: boolean
  showExtensionInstall: boolean
  skipPassword: boolean
}

const OnboardingAppContext = createContext<OnboardingAppContextValues>({
  authToken: '',
  bookmarkletJS: '',
  deviceSupportsBabylistApp: false,
  showExtensionInstall: false,
  skipPassword: false,
})

export default OnboardingAppContext
